import {
  EmailSchema,
  NameSchema,
  PhoneSchema,
  UserProfileAddressSchema
} from '@lib/form/validationSchemas'
import { z } from 'zod'

export const CustomerDetailsSchema = NameSchema.merge(EmailSchema)
  .merge(PhoneSchema)
  .extend({
    id: z.string().optional()
  })

export type AddressData = z.infer<typeof UserProfileAddressSchema>

export type CustomerDetailsData = z.infer<typeof CustomerDetailsSchema>
